/* Мобильное меню: разметка drawer рендерится в partials/header.hbs,
   JS только переключает состояние (тоггл, лок скролла, закрытие). */
export default function mobileMenu() {
    const header = document.querySelector("header.site");
    const btn = header && header.querySelector(".menu-btn");
    const drawer = header && header.querySelector(".mobile-drawer");
    if (!header || !btn || !drawer) return;

    function close() {
        header.classList.remove("menu-open");
        btn.classList.remove("on");
        btn.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
    }

    btn.addEventListener("click", () => {
        const open = header.classList.toggle("menu-open");
        btn.classList.toggle("on", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        document.body.style.overflow = open ? "hidden" : "";
    });

    drawer.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", close);
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth > 720) close();
    });
}
